export default __webpack_public_path__ + "static/jMater-ed0b38a98e9fece961d6222cc8b580d0.svg";